import angular from 'angular';
import productLabelUploadComponent from './product-label-upload.component';

export default angular.module('common.components.productLabelUpload', [])
  .component('productLabelUpload', productLabelUploadComponent)
  .value('EventEmitter', payload => ({ $event: payload }))
  .name;



// WEBPACK FOOTER //
// ./components/app/common/product-label-upload/product-label-upload.module.js